import { useSelector } from "react-redux";
import { can, canAny } from "../helpers/permission";

export default function Can({ permission, anyOf = [], children, fallback = null }) {
  const { permissions, loadingPermissions } = useSelector(
    (state) => state.PermissionReducer
  );

  if (loadingPermissions) return null;

  const allowed =
    permission
      ? can(permissions, permission)
      : anyOf.length
      ? canAny(permissions, anyOf)
      : true;

  return allowed ? children : fallback;
}
